import React, { MouseEvent } from 'react';
import './accordeon.css';

export interface AccordeonItem {
  title: string;
  subtitle: string;
  content: string | JSX.Element;
}

interface Props {
  className?: string;
  items: Array<AccordeonItem>;
}


class TeamSuccessTabContent extends React.Component<Props> {

  private currentClass = "accordeon";
  
  private currentItemClass = "accordeon-item";
  
  private activeClass = "active";
  
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  handleClick(e: MouseEvent): void {
    e.preventDefault();
    const itemNodes = document.querySelectorAll(`.${this.currentItemClass}`);
    Array.from(itemNodes).forEach((i) => i.classList.remove(this.activeClass));
    e.currentTarget.classList.add(this.activeClass)
  }
  
  accordeonItem(item: {title: string, subtitle: string, content: string | JSX.Element}, index: number): JSX.Element {
    return (
      <div
        className={ `${this.currentItemClass} ${ index === 0 ? this.activeClass : null }` } 
        key={ `accordeon-item-${index}` }
        onClick={this.handleClick}
      >
        <div className={ `${this.currentItemClass}-title` }>
          <h4 className='bold'>{ item.title }</h4>
        </div>
        <div className={ `${this.currentItemClass}-subtitle` }>{ item.subtitle }</div>
        <div className={ `${this.currentItemClass}-content` }>{ item.content }</div>
      </div>
    );
  }
  
  
  render(): JSX.Element {
    return (
      <div className={this.currentClass}>
        { this.props.items.map((item, i) => this.accordeonItem(item, i)) }
      </div>
    );
  }
}

export default TeamSuccessTabContent;
